/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConcernedParcelSubjectKulturaUsedAcreagePk } from './concernedParcelSubjectKulturaUsedAcreagePk.model';
import { LpisKultura } from './lpisKultura.model';
import { ParcelBarterDto } from './parcelBarterDto.model';


export interface ConcernedParcelSubjectKulturaUsedAcreageDto { 
    acreage?: number;
    concernedParcelSubjectKulturaUsedAcreagePk?: ConcernedParcelSubjectKulturaUsedAcreagePk;
    concernedSubjectId?: number;
    lpisKultura?: LpisKultura;
    lpisKulturaId?: number;
    lpisUserId?: number;
    opsubId?: number;
    parId?: number;
    parcel?: ParcelBarterDto;
    parcelId?: number;
    rentedWithoutFurtherRent?: boolean;
    subjectId?: number;
}

